import { css } from 'styled-components';
export const DELAYS = {
    0: 0,
    1: 250,
    2: 500,
    3: 750,
    4: 1000,
    5: 1250,
    6: 1500,
    7: 1750,
    8: 2000,
    9: 2250,
};
const DURATION = '500ms';
export function fadeInAnimation(delay) {
    return css `
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    opacity: 0;
    animation: ${DURATION} linear ${delay}ms 1 both fadeIn;
  `;
}
//# sourceMappingURL=fadeInAnimation.js.map